let cachedData = null;

export function setStatusData(data) {
  cachedData = data;
}

export function getStatusData() {
  return cachedData;
}

export function clearStatusData() {
  cachedData = null;
}
